import styled from '@emotion/styled';
import { useEffect } from 'react';
import { i18n, mediaQuery, showMessage, useFinishOfflinePurchase, useGeneralSoContext } from 'src/common';
import { useGetOfferById } from 'src/common/api/apollo/queries';
import { Flex, ThankYouCard } from 'src/components';
import { footer, header } from 'src/theme';

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const CheckoutSuccessOfflinePage = () => {
  const { offerId, soId } = useGeneralSoContext();
  const { offer } = useGetOfferById();
  const [finishOfflinePurchase] = useFinishOfflinePurchase();

  useEffect(() => {
    if (!soId || !offerId) return;

    finishOfflinePurchase()
      .catch(() => {
        showMessage({
          type: 'error',
          message: i18n.t('common.messages.policyErrorMessage'),
          duration: 5000,
          fixed: true,
        });
      })
      .finally(() => {
        window.sessionStorage.clear();
      });

  }, [soId, offerId]);

  return (
    <FlexStyle justify="center" align="center">
      <ThankYouCard offer={offer} variant="offline" />
    </FlexStyle>
  );
};

export default CheckoutSuccessOfflinePage;
